import type { ButtonHTMLAttributes } from 'react';
export function Button({className = '', ...props}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button data-ui="button" className={'ui-button ' + className} {...props}/>;
}
